(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aya-product-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
  const updateReviewVisibility = () => {
    document.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      const rawCount = badge.getAttribute('data-number-of-reviews');

      if (rawCount === null) {
        return;
      }

      const wrapper = badge.closest('.shopify-block') || badge;
      wrapper.hidden = Number(rawCount) <= 0;
    });
  };

  document.addEventListener('DOMContentLoaded', updateReviewVisibility);
  document.addEventListener('shopify:section:load', updateReviewVisibility);

  const reviewObserver = new MutationObserver(updateReviewVisibility);
  reviewObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aya-soldout-whatsapp"] && !Shopify.designMode) return;
  try {
    (()=>{const norm=s=>(s||'').trim().toLowerCase();const setupSoldoutWhatsapp=(root=document)=>{root.querySelectorAll('[data-aya-soldout-whatsapp]').forEach(box=>{if(box.dataset.ayaReady==='true')return;box.dataset.ayaReady='true';const link=box.querySelector('[data-aya-whatsapp-link]');if(!link)return;link.addEventListener('click',()=>{link.removeAttribute('target');const isPt=box.dataset.ayaLanguage==='pt';const productInfo=box.closest('.product__info')||document;const title=productInfo.querySelector('.product-meta__title')?.textContent?.trim()||document.title;const selectors=[...productInfo.querySelectorAll('.product-form__option-selector')];const sizeSelector=selectors.find(selector=>{const name=norm(selector.querySelector('.product-form__option-name')?.textContent);return name.includes('talla')||name.includes('size')||name.includes('tamanho')});let soldoutSize='';if(sizeSelector){const checkedSoldout=sizeSelector.querySelector('.block-swatch.is-disabled input:checked + label');soldoutSize=checkedSoldout?.textContent?.trim()||''}let message;if(isPt){const sizeText=soldoutSize?` O tamanho selecionado é ${soldoutSize}.`:' O tamanho de que preciso aparece esgotado.';message=`Olá, estou interessada em "${title}".${sizeText} Podem tentar consegui-lo? ${window.location.href}`}else{const sizeText=soldoutSize?` La talla seleccionada es ${soldoutSize}.`:' La talla que necesito aparece agotada.';message=`Hola, estoy interesada en "${title}".${sizeText} ¿Podéis intentar conseguirla? ${window.location.href}`}link.href=`https://wa.me/34686140859?text=${encodeURIComponent(message)}`})})};document.addEventListener('DOMContentLoaded',()=>setupSoldoutWhatsapp());document.addEventListener('shopify:section:load',e=>setupSoldoutWhatsapp(e.target))})();
  } catch(e) { console.error(e); }
})();

})();
